import { DetailSubsection } from '../DetailSubsection';
import React from 'react';
import { SuggestionButton } from '@ui/general/SuggestionButton';
import { SuggestTextEditor } from '@ui/text/SuggestTextEditor';
import { When } from 'react-if';
import { AutodocType, coreActions } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction, useSonarObjectReference, useSuggestionEditor } from '@hooks';

export interface BusinessContextDefinitionProps {
	autodocDisabled?: boolean;
	sonarObjectId: number;
}

export const BusinessContextDefinition: React.FC<BusinessContextDefinitionProps> = ({
	autodocDisabled,
	sonarObjectId
}) => {
	const definition = useSonarObjectReference(sonarObjectId)?.context?.definition ?? '';
	const autodocType = AutodocType.Definition;

	const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);

	const suggestion = useSuggestionEditor({
		autodocType,
		richText: true,
		sonarObjectId,
		value: definition
	});

	const handleSave = (content: string) => {
		updateSonarObjectContext({
			context: { definition: content },
			sonarObjectId
		});
	};

	const showSuggestButton = !autodocDisabled && !suggestion.isEditing && !suggestion.value && !suggestion.loading;

	return (
		<DetailSubsection
			title={ COPY_SPECIFIC.DEFINITION }
			titleExtra={
				<When condition={ showSuggestButton }>
					<SuggestionButton
						autodocType={ autodocType }
						onClick={ suggestion.request } />
				</When>
			}>
			<SuggestTextEditor
				autodocType={ autodocType }
				canBeEmpty
				onSave={ handleSave }
				placeholder={ PLACEHOLDERS_COPY.ADD_A_BUSINESS_DEFINITION }
				sonarObjectId={ sonarObjectId }
				suggestion={ suggestion }
				value={ definition ?? '' } />
		</DetailSubsection>
	);
};
